import { makeVar, useReactiveVar } from '@apollo/client';

const isNotificationSideDrawerVisible = makeVar(false);

interface UseNotificationSideDrawerVisibility
  extends UseNotificationSideDrawerOperations {
  isVisible: boolean;
}

interface UseNotificationSideDrawerOperations {
  setVisibility(isVisible: boolean): void;
  hideNotificationSideDrawer(): void;
}

function setVisibility(isVisible: boolean) {
  isNotificationSideDrawerVisible(isVisible);
}

function hideNotificationSideDrawer(): void {
  if (isNotificationSideDrawerVisible()) {
    setVisibility(false);
  }
}

export function useNotificationSideDrawerOperations(): UseNotificationSideDrawerOperations {
  return { setVisibility, hideNotificationSideDrawer };
}

export default function useNotificationSideDrawerVisibility(): UseNotificationSideDrawerVisibility {
  const isVisible = useReactiveVar(isNotificationSideDrawerVisible);

  return { isVisible, setVisibility, hideNotificationSideDrawer };
}
